import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/Layout";
import Wysiwyg from "../components/Wysiwyg";
import { YoastSeo } from "../components/SEO";

const Page = ({ data: { page } }) => {
  return (
    <Layout dark={page?.pageSettings?.darkMode}>
      <YoastSeo title={page.title} yoast={page.seo?.fullHead} />
      <div className="container grid grid-cols-3 gap-x-12 lg:grid-cols-detail">
        <main className="col-span-3 py-12 lg:col-span-2 xl:col-span-1 xl:col-start-2">
          <Wysiwyg>{page.content}</Wysiwyg>
        </main>
      </div>
    </Layout>
  );
};

export default Page;

export const query = graphql`
  query ($id: String!) {
    page: wpPage(id: { eq: $id }) {
      title
      content
      seo {
        fullHead
      }
      pageSettings {
        darkMode
      }
    }
  }
`;
